import * as React from 'react';
import { emitDesktopSidebarToggleEvent, getSidebarStateStorage, useSidebarToggleEvent } from '../sidebarState';
import { sidebarToggleEventId } from '../sidebarState/sidebarState.constants';
export function useDesktopSidebar() {
  const [sidebarOpen, setSidebarOpen] = React.useState(() => {
    try {
      return getSidebarStateStorage().getState();
    } catch (e) {
      return false;
    }
  });
  const handleSidebarToggle = React.useCallback(() => {
    setSidebarOpen(prevState => !prevState);
  }, []);
  React.useEffect(() => {
    emitDesktopSidebarToggleEvent(sidebarOpen);
  }, [sidebarOpen]);
  useSidebarToggleEvent(sidebarToggleEventId, forcedValue => {
    setSidebarOpen(previousValue => {
      const nextValue = forcedValue !== undefined ? forcedValue : !previousValue;
      getSidebarStateStorage().setState(nextValue);
      return nextValue;
    });
  });
  return [sidebarOpen, handleSidebarToggle];
}